export default {
  admin: 'Администратор',
  iin: 'ИИН',
  ecp: 'ЭЦП',
  user_iin: 'ИИН пользователя',
  personnel_number: 'Табельный номер',
  photo: 'Фотография',
  photos: 'Фотографии',
  password: 'Пароль',
  login: 'Логин',
  user_name: 'Имя пользователя',
  sign_in: 'Войти',
  logout: 'Выйти',
  main: 'Главная',
  main_test: 'Главный тест',
  all_name: 'Все {name} ',
  optional: 'опционально',
  date: 'Дата',
  time: 'Время',
  login_for_auth: 'Логин для авторизации',
  password_for_auth: 'Пароль для авторизации',
  min: 'мин',
  type: 'Тип',
  number: 'Номер',
  accept_entire_region: 'Принять весь регион',
  FIO_long: 'Фамилия Имя Отчество',
  fio_small: 'ФИО',
  testing_started: 'Тестирование началось',
  accept: 'Принять',
  reject: 'Отклонить',
  rejected: 'Отклонен',
  user_fio: 'ФИО  пользователя',
  nomination: 'Наименование',
  nomination_plan: 'Наименование Курса',
  nomination_theme: 'Наименование темы',
  nomination_test: 'Наименование теста',
  nomination_package: 'Наименование пакета',
  nomination_exam: 'Наименование экзамена',
  nomination_webinar: 'Наименование вебинара',
  nomination_lesson: 'Наименование урока',
  nomination_certificate: 'Наименование сертификата',
  nomination_audience: 'Наименование аудитории',
  nomination_file: 'Наименование файла',
  file: 'Файл',
  every_auth_date: 'даты каждой авторизации',
  registration_datetime: 'дата и время регистрации',
  list_attached_exams: 'список прикрепленных экзаменов',
  theme: 'Тема',
  exam_date: 'Дата экзамена',
  theme_type: 'Тип темы',
  theme_1: 'Тематика',
  duration: 'Длительность',
  duration_1: 'Продолжительность',
  duration_2: 'Продолжи- <br> тельность',
  condition_passing: 'Условие прохождения',
  condition_passing_test: '% правильных ответов (от 0 до 100%)',
  status: 'Статус',
  materials: 'материалы',
  educationPlan: 'Расписание',
  educationPlans: 'Расписания',
  plan: 'Расписание',
  planName: 'Название темы',
  name: 'Название',
  name_1: 'Имя',
  themeName: 'Название темы',
  new_exam: 'Новый экзамен',
  themes: 'Темы',
  verification_method: 'Способ проверки',
  subdivision: 'Класс',
  subject: 'Предмет',
  branch: 'Филиал',
  certificate: 'Сертификат',
  mew_certificate: 'Новый сертификат',
  change_certificate: 'Изменить сертификат',
  professions_list: 'Список должностей',
  exam: 'Экзамен',
  download: 'Скачать',
  education_type: 'Предметы',
  education_plan_description: 'Описание расписания',
  short_description: 'Краткое описание',
  education_type_1: 'Тип обучения',
  hour: 'Час | Часа | Часов',
  walkthrough: 'Прохождения',
  thematic_plan: 'Тематический курс',
  more: 'Подробнее',
  check_type: 'Тип проверки',
  about_theme: 'O теме',
  theme_info: 'Информация о теме',
  lesson_type: 'Тип урока',
  lesson_plan: 'План урока',
  outline: 'План изложения',
  benefits: 'Пособия',
  equipment: 'Оборудование',
  about_test: 'О тесте',
  test_info: 'Информация о тесте',
  conditions_passage: 'Условия прохождения',
  industrial: 'Производственное',
  industrial_1: 'Производственный',
  theoretical: 'Теоретическое',
  theoretical_1: 'Теоретический',
  exams_and_tests: 'Экзамены и тесты',
  tests: 'Тесты',
  new_test: 'Новый тест',
  questions: 'Вопросы',
  question_text: 'Текст вопроса',
  retakes: 'Пересдачи',
  retake_date: 'Дата пересдачи',
  retake_time: 'Время пересдачи',
  new_retake: 'Новая пересдача',
  description: 'Описание',
  terms: 'Условия',
  question: 'Вопрос | Вопроса | Вопросов',
  test: 'Тест | Теста | Тестов',
  results: 'Результаты',
  result: 'Результат',
  passed: 'Прошли',
  average_result: 'Результат средний',
  start_testing: 'Начать тестирование',
  completed_exam: 'Завершили экзамен',
  testing: 'Тестирование',
  of: 'из',
  hrs: 'ч',
  start_exam: 'Начать экзамен',
  start: 'Начать',
  exams: 'Экзамен',
  exams_ml: 'Экзамены',
  examiners: 'Экзаменаторы',
  completed: 'Завершен',
  complete_webinar: 'Завершить вебинар',
  share_screen: 'Поделиться экраном',
  off_share_screen: 'Отключить показ экрана',
  watch_now: 'Сейчас смотрят',
  examiner: 'Экзаменатор',
  change_examiner: 'Изменить экзаменатора',
  new_examiner: 'Новый экзаменатор',
  examiner_fio: 'ФИО экзаменатора',
  examiner_fio_1: 'ФИО проводящего вебинар',
  surname: 'Фамилия',
  examiner_surname: 'Фамилия экзаменатора',
  examiner_name: 'Имя экзаменатора',
  examiner_middle_name: 'Отчество экзаменатора',
  middle_name: 'Отчество',
  examiner_iin: 'ИИН экзаменатора',
  examiner_login: 'Логин экзаменатора',
  examiner_password: 'Пароль экзаменатора',
  examiner_name_surname: 'Имя Фамилия экзаменатора',
  exam_start_date: 'Дата начала экзамена',
  passed_start_exam: 'Прошло с начала экзамена',
  password_for_ecp: 'Пароль для ЭЦП',
  report_card: 'Табель',
  sign_ecp: 'Подписать ЭЦП',
  admin_report_card: 'Табель администратора',
  analytic: 'Аналитика',
  exam_analytic: 'Аналитика экзамена',
  topics_wrong_answers: 'Неправильные ответы по темам',
  topics_right_answers: 'Правильные ответы по темам',
  current_webinars: 'Текущие вебинары',
  all_webinars: 'Все вебинары',
  webinars: 'Вебинары',
  webinar_date: 'Дата вебинара',
  lesson_date: 'Дата урока',
  teacher_fullname: 'ФИО проводящего',
  live_stream: 'Прямая трансляция',
  watch_record: 'Посмотреть запись',
  webinar_start_date: 'Дата начала вебинара',
  start_date: 'Дата начала',
  webinar_beginner_time: 'Прошло с начала вебинара',
  until_webinar: 'До окончания вебинара',
  ask_question: 'Задать вопрос',
  connect: 'Подключиться',
  coming_webinar: 'Предстоящие вебинары',
  will_start: 'Начнется через',
  camera: 'Камера',
  face_not_recognized: 'Лицо не распознано',
  cancel: 'Отмена',
  image: 'Изображение',
  important: 'Важно',
  check_camera: ['Убедитесь что камера работает', 'Посмотрите ровно на камеру', 'Ждите пока вас распознает система'],
  past_webinar: 'Прошедшие вебинары',
  scorm_package: 'Scorm пакеты',
  scorm_package_1: 'scorm пакета',
  not_passed: 'Не пройден',
  run: 'Запустить',
  scormPackageIframe: 'Вводный курс по охране труда, промышленной безопасности и охране окружающей среды',
  mediafiles: 'Медиафайлы',
  create_mediafile: 'Новый медиафайл',
  change_mediafile: 'Изменить медиафайл',
  prev: 'Назад',
  next: 'Вперед',
  remove: 'Удалить',
  region: 'Регион',
  exam_result: 'Результаты экзамена',
  question_count: 'Количество вопросов',
  test_duration: 'Продолжительность теста',
  webinar_duration: 'Продолжительность вебинара',
  lesson_duration: 'Продолжительность урока',
  minute: 'Минута | Минуты | Минут',
  before_exam_end: 'До окончания экзамена',
  complete_exam: 'Завершить экзамен',
  test_time_up: 'Время тестирования вышло!',
  testing_time: 'Время тестирования',
  ok: 'Окей',
  webinar_testing_desc: 'Во время вебинара могут проводится несколько тестировании',
  webinar_time: 'Время вебинара',
  lesson_time: 'Время урока',
  no_message: 'Пока нет сообщений',
  upload_file: 'Загрузить файл',
  uploading: 'Загружаем',
  write: 'Написать',
  close: 'Закрыть',
  webinar_chat: 'Чат по вебинару',
  webinar_name: 'Название вебинара',
  webinar_question_for: 'Вопрос по вебинару для',
  send: 'Отправить',
  answer: 'Ответ',
  set_password: 'Задайте пароль',
  change_password: 'Изменить пароль',
  current_password: 'Текущий пароль',
  new_password: 'Новый пароль',
  repeat_new_password: 'Повторите новый пароль',
  password_mismatch: 'Пароли не совпадают',
  password_min_length: 'Минимальная длинна пароля 4 символа',
  save: 'Сохранить',
  statistics: 'Статистика',
  visits_log: 'Журнал посещений',
  users: 'Пользователи',
  video_lessons: 'Видеоуроки',
  video_lesson: 'Видеоурок',
  not_completed_video_lesson: 'Не пройденные видеоуроки',
  completed_video_lesson: 'Пройденные видеоуроки',
  create_webinar: 'Создать вебинар',
  create_webinar_1: 'Создания вебинара',
  create_lesson: 'Создания видеоурока',
  update_lesson: 'Редактирование видеоурока',
  create: 'Создать',
  webinar_teachers: 'Проводящие вебинар',
  webinar: 'Вебинар',
  webinar_questions: 'Вопросы по вебинару',
  admin_questions: 'Вопросы администратора',
  certificates: 'Сертификаты',
  roles: 'Роли',
  audience_exam: 'Экзамен аудитории',
  new_audience_exam: 'Новая аудитория экзамена',
  change_audience_exam: 'Изменить аудиторию экзамена',
  audience: 'Аудитория',
  download_report: 'Скачать Отчет',
  course_attendance: 'Посещаемость на курсы',
  test_turnout: 'Явка на тест',
  received_certification: 'Получили аттестацию',
  download_excel: 'Скачать Excel',
  education_theme: 'Тема обучения',
  item_list: 'Перечень предметов',
  visit: 'Посещение',
  education_times: 'Часов обучения',
  position: 'Должность',
  position_1: 'Позиция',
  select_position: 'Выберете должность',
  user_type: 'Тип пользователя',
  time_sheet: 'Табельный',
  auth_date: 'Дата <br>авторизации',
  retake: 'Пересдача',
  assign_retake: 'Назначить пересдачу',
  assign_retakes_list: 'Список назначенных пересдач',
  assign: 'Назначить',
  import_database: 'Импорт базы данных',
  create_user: 'Создать пользователя',
  registration_date: 'Дата регистрации',
  create_recording_webinar: 'Cоздания записи проводящего вебинар',
  change_recording_webinar: 'Изменение записи проводящего вебинар',
  webinar_started_through: 'Вебинар можно будет начать через',
  teacher_login: 'Логин проводящего',
  availability_photo: 'Наличие фото',
  timetable: 'Расписание',
  user_photos: 'Фотографии пользователя',
  upload_photo: 'Загрузить Фото',
  upload: 'Загрузить',
  attach_plan: 'Расписание',
  attach: 'Прикрепить',
  block: 'Заблокировать',
  unlock: 'Разблокировать',
  gradebook: 'Журнал успеваемости',
  hours_cnt: 'Кол-во часов',
  new_user: 'Новый пользователь',
  change_webinar: 'Изменить вебинар',
  max_upload: 'Файл не должен превышать {size}',
  max_uploads: 'Размер файла не должен превышать {size}',
  questions_template: 'Шаблон для загрузки вопросов (опционально)',
  download_questions_template: 'Шаблон вопросов',
  max_upload_video: 'Видео {size}',
  upload_one_file: 'Загрузите 1 файл',
  upload_multiple: 'Возможна загрузка нескольких файлов',
  size: {
    mb: 'Мегабайта'
  },
  export: 'Экспорт',
  export_users: 'Экспорт пользователей',
  import: 'Импорт',
  create_plan: 'Создать курс',
  change_plan: 'Изменить курс',
  change: 'Изменить',
  occupational_professions: 'Профессии',
  themes_count: 'Кол-во тем',
  students: 'Обучающихся',
  education_plan_name: 'Наименование курса',
  exam_type: 'Тип экзамена',
  new_theme: 'Новая тема',
  change_theme: 'Изменить тему',
  theme_number: 'Номер темы',
  training_number: 'Порядковый номер в курсе',
  serial_number: 'Порядковый номер',
  theme_description: 'Описание темы',
  new_material_outline: 'План изложения нового материала',
  list_equipment_used: 'Перечень применяемого оборудования',
  list_educational_aids: 'Перечень учебно наглядных пособий',
  count_hours_study: 'Количество часов обучения',
  test_relate_webinar: 'Тест относится к вебинару',
  test_relate_videolesson: 'Тест относится к видеоуроку',
  change_test: 'Изменить тест',
  new_question: 'Новый вопрос',
  change_question: 'Изменить вопрос',
  possible_answer: 'Вариант ответа',
  correct_answer: 'Правильный ответ',
  class_room: 'Класс',
  change_retake: 'Изменить пересдачу',
  update: 'Обновить',
  enter: 'Введите',
  exam_audience: 'Аудитория экзамена',
  exam_time: 'Время экзамена',
  change_exam: 'Изменить экзамен',
  kazlang: 'Казахский язык',
  math: 'Математика',
  search_request: 'Поисковой запрос',
  search: 'Поиск',
  error: 'Ошибка',
  retake_cnt: 'Количество пересдач',
  watched: 'Просмотрен',
  education_plan: 'План обучения',
  change_user_plan: 'Прикрепить план ',
  day_locale: {
    'Mon': 'ПН',
    'Tue': 'ВТ',
    'Wed': 'СР',
    'Thu': 'ЧТ',
    'Fri': 'ПТ',
    'Sat': 'СБ',
    'Sun': 'ВС'
  },
  month_locale: {
    'Jan': 'Январь',
    'Feb': 'Февраль',
    'Mar': 'Март',
    'Apr': 'Апрель',
    'May': 'Май',
    'Jun': 'Июнь',
    'Jul': 'Июль',
    'Aug': 'Август',
    'Sep': 'Сентябрь',
    'Oct': 'Октябрь',
    'Nov': 'Ноябрь',
    'Dec': 'Декабрь'
  },
  meets: 'Переговоры',
  dictionary: 'Словарь',
  dictionary_create: 'Добавление в Словарь',
  dictionaryTypes: 'Типы словарей',
  title: 'Заголовок',
  forPsychologist: 'Для психологов',
  super_user: {
    title: 'СуперПользователи',
    create: 'Создание СуперПользователя',
    edit: 'Редактирование СуперПользователя'
  },
  support_user: {
    title: 'Пользователи Поддержки',
    create: 'Создание пользователя поддержки',
    edit: 'Редактирование пользователя поддержки'
  },
  support: 'Поддержка',
  skip: 'Пропустить',
  forgetPassword: 'Забыли пароль?',
  restore: 'восстановить',
  recovery_request_sent: 'Запрос на восстановление отправлен',
  restoration_request: 'Запросы на восстановление',
  your_support_request: 'Ваши обращения в техподдержку',
  opened: 'Открытые',
  closed: 'Зыкрытые',
  supportRequestType: 'Тип обращения',
  supportRequestText: 'Текст обращения',
  passwordError: 'Ошибка пароля',
  passwordRules: {
    ruleUpperLatin: 'Заглавная и строчная буквы на лат.',
    ruleNumber: 'Содержит цифры',
    ruleSpecial: 'Содержит спец. символы: !@#$%^&*',
    ruleMinLength: 'Минимум {data} символов'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/ru.js